import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Test preset: Canvas selection with radio-button groups.
 *
 * Three on-canvas radio buttons placed at points on the graph.
 * Clicking a radio button sets the slope (m) of a linear function
 * so the line passes through that point (all with y-intercept b=0).
 *
 * Points: (-2, -2) → m=1, (2, 4) → m=2, (4, -2) → m=-0.5
 */
export const TEST_CANVAS_SELECTION_PRESET: GraphpadWidgetConfig = {
  id: 'test-canvas-selection',
  type: 'graphpad',
  params: {
    f: {
      type: 'linear',
      params: { m: 1, b: 0 },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -5, xEnd: 6, yStart: -4, yEnd: 6 },
      grid: { type: 'lines', visible: true },
    },
    elements: {
      f: {
        curve: { color: 'sky' },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'cs-point-a',
        type: WIDGET_CONTROL_TYPE.CanvasSelection,
        label: 'Point A (m=1)',
        location: { x: -2, y: -2 },
        group: 'slope-select',
        selected: true,
        trigger: {
          action: 'UPDATE_PARAM',
          payload: { param: 'f.m', value: 1 },
        },
      },
      {
        id: 'cs-point-b',
        type: WIDGET_CONTROL_TYPE.CanvasSelection,
        label: 'Point B (m=2)',
        location: { x: 2, y: 4 },
        group: 'slope-select',
        trigger: {
          action: 'UPDATE_PARAM',
          payload: { param: 'f.m', value: 2 },
        },
      },
      {
        id: 'cs-point-c',
        type: WIDGET_CONTROL_TYPE.CanvasSelection,
        label: 'Point C (m=-0.5)',
        location: { x: 4, y: -2 },
        group: 'slope-select',
        trigger: {
          action: 'UPDATE_PARAM',
          payload: { param: 'f.m', value: -0.5 },
        },
      },
    ],
  },
};
